import React, { FunctionComponent, MutableRefObject } from 'react';
import { EditorRef } from 'react-email-editor';

import { PrimaryButton, TertiaryButton, TextButton } from '@components/library/button';

import { PressReleaseFormSteps, PressReleaseValidationErrors } from './PressReleaseTypes';

import classes from './styles/press_release_form_footer.module.scss';

interface PressReleaseFormFooterProps {
  drafting: boolean;
  emailEditorRef: MutableRefObject<EditorRef | null>;
  handleStep1: () => void;
  handleStep2: () => void;
  handleStep3: (action: 'drafting' | 'sending' | 'testing') => void;
  saving: boolean;
  sending: boolean;
  step: PressReleaseFormSteps;
  testing: boolean;
  validationErrors: PressReleaseValidationErrors;
}

export const PressReleaseFormFooter: FunctionComponent<PressReleaseFormFooterProps> = (props) => {
  const { drafting, emailEditorRef, handleStep1, handleStep2, handleStep3, saving, sending, step, testing, validationErrors } = props;

  switch (step) {
    case 1:
      return (
        <PrimaryButton
          className={classes.nextButton}
          disabled={!emailEditorRef?.current?.editor}
          id="next-select-recipients"
          onClick={(): void => {
            handleStep1();
          }}
        >
          {bfTranslate('Next: Select Recipients')}
        </PrimaryButton>
      );
    case 2:
      return (
        <PrimaryButton
          className={classes.nextButton}
          disabled={!validationErrors.valid}
          id="next-preview-email"
          isLoading={saving}
          onClick={(): void => {
            handleStep2();
          }}
        >
          {bfTranslate('Next: Preview Email')}
        </PrimaryButton>
      );
    case 3:
      return (
        <div className={classes.buttons}>
          <TextButton
            className={classes.testButton}
            disabled={saving && !testing}
            icon="bff-sent"
            iconSize={16}
            id="test-email"
            isLoading={testing}
            loadingCopy={bfTranslate('Sending test...')}
            onClick={(): void => {
              handleStep3('testing');
            }}
          >
            {bfTranslate('Send a test to myself')}
          </TextButton>
          <div className={classes.saveAndSendButtons}>
            <TertiaryButton
              className={classes.saveButton}
              disabled={sending || testing}
              icon="bff-draft"
              iconSize={16}
              id="save-email-as-draft"
              isLoading={drafting}
              loadingCopy={bfTranslate('Saving draft...')}
              onClick={(): void => {
                handleStep3('drafting');
              }}
            >
              {bfTranslate('Save as Draft')}
            </TertiaryButton>
            <PrimaryButton
              className={classes.sendButton}
              disabled={saving && !sending}
              icon="bff-sent"
              iconSize={16}
              id="send-email"
              isLoading={sending}
              loadingCopy={bfTranslate('Sending...')}
              onClick={(): void => {
                handleStep3('sending');
              }}
            >
              {bfTranslate('Send Email')}
            </PrimaryButton>
          </div>
        </div>
      );
    default:
      return (
        <></>
      );
  }
};
